import React from 'react';
import { Dropdown } from 'antd';
import { ReactComponent as FilterIcon } from '../../../../../../../../resource/AdaptiveFilterIcon.svg';
import Overlay from './overlay';
import { useEvent } from '../../../../../../../../hooks/useEvent';
import FilterBtn from '../FilterBtn';
import { useFilterState } from '../state';
import { getPopupContainer } from '../utils';

const emptyArr = [];

const SelectFilter = ({
  name,
  multiple = false,
  items = emptyArr,
  loading,
  errorMessage,
  refetch,
}) => {
  const {
    value,
    setValue,
    visible,
    onVisibleChange,
    onOk,
    onReset,
    hasFilterValue,
  } = useFilterState(name);

  const handleItemClick = useEvent((value, selected) => {
    setValue((prev) => {
      if (!multiple) {
        return selected ? value : prev;
      }

      const prevArr = Array.isArray(prev) ? prev : [];
      return selected
        ? [...prevArr, value]
        : prevArr.filter((v) => v !== value);
    });
  });

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      onVisibleChange={onVisibleChange}
      getPopupContainer={getPopupContainer}
      overlay={
        <Overlay
          value={value}
          items={items}
          multiple={multiple}
          errorMessage={errorMessage}
          refetch={refetch}
          onItemClick={handleItemClick}
          onOk={onOk}
          onReset={onReset}
        />
      }
    >
      <FilterBtn
        active={hasFilterValue}
        iconType={loading ? 'loading' : undefined}
        iconComponent={loading ? undefined : FilterIcon}
      />
    </Dropdown>
  );
};

export default SelectFilter;
